<aside class="hidden lg:flex flex-col gap-4 !max-h-[100dvh] justify-end relative">
  <section class="flex flex-col gap-4 border border-solid rounded-lg p-4 shadow-sm cursor-pointer" #topSection
    (click)="showDatePickerModal()">
    <div *ngIf="searchBoxService.accommodation() != 'ecolodge'"
      class="w-full h-fit p-2 bg-blue-50 border-solid border-2 border-blue-300 rounded-md text-blue-500">
      برای مشاهده قیمت‌های‌ دقیق‌تر، تاریخ ورود و خروج را انتخاب کنید.
    </div>
    <div *ngIf="searchBoxService.accommodation() == 'ecolodge' && isShowAlertCount"
      class="w-full h-fit p-2 bg-red-50 flex items-center  rounded-md text-red-500">
      <i class="ico-InformationCircle mx-1 text-xl bg-red-100 px-1 rounded-full"></i>
      <span>لطفاً تعداد نفرات را مشخص کنید!</span>
    </div>
    <div class="iho-autocomplete relative">
      <div ihoAutocomplete>
        <mat-form-field appearance="outline" class="w-full density-settings-0">
          <mat-label class="!text-lg">
            {{searchBoxService.accommodation() == 'ecolodge' ? 'جستجوی شهر، منطقه یا ویلا' : 'مقصد یا هتل'}}
          </mat-label>
          <input matInput class="!font-bold"
            [value]="autoCompleteService._selectedItem().name !== undefined ? autoCompleteService._selectedItem().name : ''">
          <mat-icon matPrefix>
            <i class="p-4 ico-Location text-2xl text-gray-500"></i>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="w-[140%] absolute -left-[25px]">  
        <iho-autocomplete />
      </div>
    </div>
    <div class="iho-datepicker flex flex-col relative">
      <div ihoDatepicker class="grid grid-cols-1 space-y-4 xl:grid-cols-2 xl:gap-2 xl:space-y-0">
        <mat-form-field appearance="outline" class="w-full m-0 p-0 density-settings-0">
          <mat-label class="!text-lg">
            تاریخ ورود
          </mat-label>
          <input matInput class="!font-bold" readonly autocomplete="off" [value]="datePickerService._customStartDate()">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Calender text-2xl text-gray-500"></i>
          </mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full m-0 p-0 density-settings-0" disabled>
          <mat-label class="!text-lg">
            تاریخ خروج
          </mat-label>
          <input matInput class="!font-bold" readonly autocomplete="off" [value]="datePickerService._customEndDate()">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Calender text-2xl text-gray-500"></i>
          </mat-icon>
        </mat-form-field>
      </div>

      <div *ngIf="datePickerService._allowToShow()" class="absolute top-14 left-[680px]">
        <ng-container *ngComponentOutlet="csrStatus()"></ng-container>
      </div>

    </div>
    <button mat-flat-button color="primary" (click)="search()" [disabled]="flagDisBtn" class="w-full !h-11">
      جستجو
    </button>
    <ng-container *ngIf="searchBoxService.accommodation() == 'ecolodge'">
      <div>
        <iho-extra-person-counter [FixedGuestCount]="pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount"
          [extraPersonData]="pdpUiService.hotelInfo()?.PersonCapacity?.ExtraGuestCount"
          (extraPersonOutput)="setNop($event)" />
      </div>
      <div class="min-h-[110px]" id="pdp-price-details">
        <ng-container *ngIf="showLoading">
          <div class="mb-3 mx-auto w-[29%]">
            <iho-skeleton height="1.5rem" width="5rem" />
          </div>
          <div class="flex justify-between">
            <iho-skeleton height="1.5rem" width="8rem" />
            <iho-skeleton height="1.5rem" width="5rem" />
          </div>
          <div class="w-full mt-3">
            <iho-skeleton height="2.75rem" width="100%" />

          </div>
          <div class="w-full mt-3">
            <iho-skeleton height="2.75rem" width="100%" />

          </div>
        </ng-container>


        <iho-pdp-price-details (isShowToast)="isShowToast($event)" *ngIf="!showLoading"
          [priceDetails]="priceDetails()" />

      </div>
    </ng-container>


  </section>
  <ng-container *ngTemplateOutlet="reserveInfo"></ng-container>
  <ng-template #reserveInfo>
    <iho-pdp-sidebar-reserve-info
      class="flex flex-col p-4 !relative rounded-lg border border-solid shadow-sm overflow-hidden pt-12"
      *ngIf="selectedRooms?.length || selectedComboRooms()?.length" id="sidebar-reserve-info"
      (removeAll)="clearSelectedRooms()" (removeCountForOneRoom)="removeSpecificRoom($event)"
      [dataSource]="selectedRooms" [startDate]="startDate" [endDate]="endDate" [hotelId]="hotelId"
      [hotelName]="hotelName" [nights]="nights" [totalPrice]="totalPrice" [lowestPrice]="lowestSelectedRoomsPrice"
      [activeFiltersNames]="activeFiltersNames" [totalComboPrice]="selectedComboPrice"
      [selectedComboRooms]="selectedComboRooms()" (removeComboRooms)="removeComboRooms()" />
  </ng-template>

</aside>